export const USER_LIST = "USER_LIST";
export const USER_ID = "USER_ID"


export const usersListAction = (value) => ({
  type: USER_LIST,
  payload: value

});

export const chooseUserByAction = (value) => ({
  type: USER_ID,
  payload: value

});